export const ContentWrapStyle = () => ({
  display: 'grid',
  placeItems: 'center',
  margin: '30px 0px'
});
